<template>
  <div class="mb-1">
    <v-row v-if="prop != null" class="ma-0 mx-2">
      <div class="ma-0 pa-0 pl-2 section-item-title">
        <p class="ma-0 pa-0">{{prop}}</p>
      </div>
    </v-row>
    <slot></slot>
  </div>
</template>

<style>
.section-item-title {
  border-color: #193153;
  border-style: solid;
  border-top: none;
  border-right: none;
  border-left: none;
  border-bottom-left-radius: 10px;
  border-width: 1px;
  background-color: transparent;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  color: #393a3a;
  letter-spacing: 0;
}
</style>

<script>
export default {
  name: "SectionItemTitle",
  props: {
    prop: {
      type: String
    }
  },
  data() {
    return {};
  }
};
</script>